import { Localized } from "@fluent/react";
import { LoadingButton } from "@mui/lab";
import CheckIcon from "@mui/icons-material/Check";

interface SelectButtonProps {
    loading?: boolean;
    disabled?: boolean;
    onClick: () => void;
}

export const SelectButton: React.FC<SelectButtonProps> = ({ loading = false, disabled = false, onClick }) => {
    return (
        <LoadingButton
            loading={loading}
            disabled={disabled}
            size="small"
            color="success"
            variant="contained"
            startIcon={<CheckIcon />}
            onClick={onClick}
        >
            <Localized id="select">Wybierz</Localized>
        </LoadingButton>
    );
};
